import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum PersonRestrictionEnum {
    LEGAL_REPRESENTATIVE = 'legalRepresentative',
    REPRESENTATIVE_APPROVED = 'representativeApproved',
    SUPPORTER_APPROVED = 'supporterApproved',
    GUARDIAN_APPROVED = 'guardianApproved',
    MUNICIPALITY_WORKER = 'municipalityWorker',
}

export const personRestrictionEnumOptions = enumToOptions(PersonRestrictionEnum, 'person.enum.restriction.');
